import { startCase } from 'lodash';

export default (text) => startCase(text.toLowerCase());
